// eslint-disable-next-line no-unused-vars
import {
  isUatEnv as uat,
  isDevEnv as dev,
  isProdEnv as prod,
  isUatIntranetEnv as uatIntranet,
  isProdIntranetEnv as prodIntranet,
} from "lib/routing";

export const features = {
  redesign: dev || uat || prod,
  analytics: dev || uat || prod,
  bannerLandingPages: dev || uat || prod,
  devTools: dev || uat,
  disclosures: dev || uat || prod,
  bannersById: dev || uat || prod,
  alternativeTabbedHomePage: dev || uat,
  podcasts: dev || uat,
  isRedesignBulletin: false,
  reportLanguageInAutocomplete: dev || uat || prod,
  dedupAutoCompleteSuggestions: dev || uat || prod,
  economicForecast: dev || uat || prod,
  eventCalendar: dev || uat,
  useContentAPIForAdverts: dev || uat || prod,
  useContentAPIForAdvertStyles: dev || uat || prod,
  useInlineAdvertStyles: false,
  sortAdsByRunningOrder: dev || uat || prod,
  sortFaqBySortField: dev || uat || prod,
  events: dev || uat || prod,
  eventFilters: {
    showLocationFilters: false,
    showLanguageFilters: dev || uat || prod,
  },
  autocompleteKeywordSuggestions: dev || uat || prod,
  showSearchTooltip: dev || uat || prod,
  analystSubscriptions: dev || uat || prod,
  useContentApiForPages: {
    faq: dev || uat || prod,
    Noteworthy: dev || uat || prod,
    Noteworthy2: false,
    Geopolitics_In_Focus: dev || uat || prod,
    Geopolitics: false,
    Higher_material_and_fuel_prices: dev || uat || prod,
    Economic_Forecast: false,
    Login_terms: dev || uat || prod,
  },
  useJsApiFor: {
    "noteworthy.htm": false,
    "cpi-table.htm": dev,
    "WAAG_2021new.htm": dev,
  },
  contextMenu: {
    backIssues: dev,
    relatedReports: dev,
    fromSameAuthor: dev,
    analystBiography: dev,
    downloadPdf: dev,
    copyText: dev || uatIntranet || prodIntranet,
  },
  econDashboard: {
    fx: dev || uat || prod,
    newLabels: dev || uat || prod,
  },
  preview: {
    faq: dev || uatIntranet || prodIntranet,
    disclaimer: dev || uatIntranet || prodIntranet,
    banners: dev || uatIntranet || prodIntranet,
    landingPages: dev || uatIntranet || prodIntranet,
  },
  showRedesignReminder: dev || uat || prod,
  showGRPSurveyInvitation: dev || uat,
  serviceNotifications: dev || uat || prod,
  themesFilter: dev || uat || prod,
  isMagicLinkVisible: dev || uat || prod,
  isfeaturedResearchVisible: dev || uat || prod,
};
